module.exports = __webpack_public_path__ + "img/ruben.957f6cad.png";